import isPropValid from "@emotion/is-prop-valid";

export default (propName, target) =>
  typeof target === "string" ? isPropValid(propName) : true;
